import { call, put, takeEvery } from 'redux-saga/effects';

import API from '../../api';
import { PromptsActionTypes } from '../actions/types';
import { PromptsActionCreators } from '../actions/creators';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { toast } from '../../utilities';

export function* getPrompts(action) {
  try {
    const response = yield call(API.Prompts.getPrompts, action.payload.types);
    yield put(PromptsActionCreators.getPrompts[AsyncActionStatus.FULFILLED](response.data));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PromptsActionCreators.getPrompts[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}

export function* savePrompt(action) {
  try {
    const response = yield call(API.Prompts.savePrompt, action.payload.prompt);
    yield put(PromptsActionCreators.savePrompt[AsyncActionStatus.FULFILLED](response.data));
    yield call(toast.success, t('toastMessages.success.promptUpdated', { ns: i18next.Namespace.COMMON }));
  } catch (error) {
    const message = generateErrorMessage(error);
    yield put(PromptsActionCreators.savePrompt[AsyncActionStatus.REJECTED](message));
    yield call(toast.error, message);
  }
}


export default [
  takeEvery(
    PromptsActionTypes.getPrompts[AsyncActionStatus.PENDING],
    getPrompts,
  ),
  takeEvery(
    PromptsActionTypes.savePrompt[AsyncActionStatus.PENDING],
    savePrompt,
  ),
];
